class AtProductCard extends HTMLElement {
    constructor() {
        super();
        this.productHandle = this.dataset.productHandle;
        this.productId = this.dataset.productId;
        this.productUrl = this.dataset.productUrl;
        this.addEventListener('change', this.getVarientId)
        this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }

    connectedCallback() {
        if (this.quick_add) {
          this.enableQuickAdd();
        }
      }

      enableQuickAdd() {
        this.quick_add.addEventListener('click', this.quickAdd.bind(this));
      }

      quickAdd(evt) {
        evt.preventDefault();
        if (this.quick_add.disabled) {
          return;
        }
        this.quick_add.classList.add('loading');
        this.quick_add.setAttribute('aria-disabled', true);
  
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        };
  
        let formData = new FormData(this.form);
  
        formData.append('id', this.quick_add.dataset.productId);
        formData.append('quantity', 1);
        formData.append('sections', this.getSectionsToRender().map((section) => section.section));
        formData.append('sections_url', window.location.pathname);
  
        config.body = formData;
  
        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              return;
            }
            this.renderContents(response);
  
            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.quick_add.classList.remove('loading');
            this.quick_add.removeAttribute('aria-disabled');
          });
  
        return false;
      }

      getSectionsToRender() {
        return [{
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }];
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
          if (typeof CartDrawer !== 'undefined') {
            new CartDrawer();
          }
          if (typeof Cart !== 'undefined') {
            new Cart().renderContents(parsedState);
          }
        }));
        if (document.getElementById('Cart-Drawer')) {
          document.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
          dispatchCustomEvent('cart-drawer:open');
        }
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }

    getVarientId() {
       this.variantData = JSON.parse(this.querySelector('div[name="product-variants-json"]').textContent);
        this.varients = Array.from(this.querySelectorAll('input[type="radio"]:checked'), input => input.value);
        this.currentVarient = this.variantData.find(item => {
            return item.options.join("") == this.varients.join("")
        })
        this.getVarient(this.currentVarient.id)
    }

    getVarient(myVar) {
        const url = `/products/${this.productHandle}?variant=${myVar}&section_id=product-card-render`;
        fetch(url)
            .then(data => data.text())
            .then((content) => {
                const innerContent = new DOMParser().parseFromString(content, "text/html");
                this.innerHTML = innerContent.querySelector(`[data-product-handle='${this.productHandle}']`).innerHTML;
            })
    }
}

customElements.define('at-product-card', AtProductCard)